import { createContext } from 'react';

/**
 * Creates a React Context for the color mode.
 * This will be used to pass the toggle function down to components
 * like the sidebar without "prop drilling".
 */
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});
